import {connect} from 'react-redux';
import {bindActionCreators, type Dispatch} from 'redux';

import {isPostIdSendingForCurrentUser} from 'mattermost-redux/selectors/entities/posts';

import {showActionsDropdownPulsatingDot} from 'selectors/actions_menu';
import {setActionsMenuInitialisationState} from 'mattermost-redux/actions/preferences';
import {getConfig} from 'mattermost-redux/selectors/entities/general';

import {get, getInt} from 'mattermost-redux/selectors/entities/preferences';
import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';
import {getUser} from 'mattermost-redux/selectors/entities/users';
import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';

import {type GenericAction} from 'mattermost-redux/types/actions';
import {type Post} from 'mattermost-redux/types/posts';

import {markPostAsUnread, emitShortcutReactToLastPostFrom} from 'actions/post_actions';

import {getShortcutReactToLastPostEmittedFrom, getOneClickReactionEmojis} from 'selectors/emojis';
import {getIsPostBeingEditedInRHS, isEmbedVisible} from 'selectors/posts';
import {getHighlightedPostId} from 'selectors/rhs';
import {getIsMobileView} from 'selectors/views/browser';

import {type GlobalState} from 'types/store';

import {isArchivedChannel} from 'utils/channel_utils';
import {shouldShowActionsMenu} from 'utils/post_utils';
import Constants, {Preferences} from 'utils/constants';

import {isFeatureEnabled} from 'utils/utils';

import RhsComment from './rhs_comment';

interface OwnProps {
    post: Post;
    previousPostId: string;
    teamId: string;
}

function mapStateToProps(state: GlobalState, ownProps: OwnProps) {
    const config = getConfig(state);
    const enableEmojiPicker = config.EnableEmojiPicker === 'true';
    const teamId = ownProps.teamId || getCurrentTeamId(state);
    const channel = state.entities.channels.channels[ownProps.post.channel_id];
    const shortcutReactToLastPostEmittedFrom = getShortcutReactToLastPostEmittedFrom(state);

    const user = getUser(state, ownProps.post.user_id);
    const isBot = Boolean(user && user.is_bot);
    const highlightedPostId = getHighlightedPostId(state);
    const showActionsMenuPulsatingDot = showActionsDropdownPulsatingDot(state);
    const newEditorEnabled = isFeatureEnabled(Constants.PRE_RELEASE_FEATURES.NEW_EDITOR, state);

    let emojis = [];
    const oneClickReactionsEnabled =
        get(
            state,
            Preferences.CATEGORY_DISPLAY_SETTINGS,
            Preferences.ONE_CLICK_REACTIONS_ENABLED,
            Preferences.ONE_CLICK_REACTIONS_ENABLED_DEFAULT,
        ) === 'true';
    if (oneClickReactionsEnabled) {
        emojis = getOneClickReactionEmojis(state);
    }

    return {
        enableEmojiPicker,
        overrideUsername: getPostOverrideUsername(state, ownProps.post),
        isEmbedVisible: isEmbedVisible(state, ownProps.post.id),
        teamId,
        newEditorEnabled,
        pluginPostTypes: state.plugins.postTypes,
        channelIsArchived: isArchivedChannel(channel),
        isConsecutivePost: false, // Disabled due TIME-349
        isFlagged: get(state, Preferences.CATEGORY_FLAGGED_POST, ownProps.post.id, null) != null,
        compactDisplay:
            get(
                state,
                Preferences.CATEGORY_DISPLAY_SETTINGS,
                Preferences.MESSAGE_DISPLAY,
                Preferences.MESSAGE_DISPLAY_DEFAULT,
            ) === Preferences.MESSAGE_DISPLAY_COMPACT,
        shouldShowActionsMenu: shouldShowActionsMenu(state, ownProps.post),
        showActionsMenuPulsatingDot,
        shortcutReactToLastPostEmittedFrom,
        isBot,
        shouldHighlight: highlightedPostId === ownProps.post.id,
        oneClickReactionsEnabled,
        recentEmojis: emojis,
        isExpanded: state.views.rhs.isSidebarExpanded,
        isPostBeingEdited: getIsPostBeingEditedInRHS(state, ownProps.post.id),
        isMobileView: getIsMobileView(state),
        isSending: isPostIdSendingForCurrentUser(state, ownProps.post.id),
        rhsWidth: getInt(state, Preferences.CATEGORY_SIDEBAR_SETTINGS, Preferences.SIDEBAR_RIGHT_WIDTH, 0),
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators(
            {
                markPostAsUnread,
                emitShortcutReactToLastPostFrom,
                setActionsMenuInitialisationState,
            },
            dispatch,
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RhsComment);
